var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlashGreen = function SvgIconFlashGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.465 6.781H12.11a.537.537 0 0 1-.527-.639l.692-5.003c.076-.53-.541-.858-.917-.468L.163 12.268c-.346.358-.105.95.376.95H5.88c.331 0 .587.297.527.64l-.692 5.003c-.075.53.542.858.918.468L17.826 7.732c.361-.343.12-.95-.36-.95Z",
    fill: "#84C47C"
  })));
};
export default SvgIconFlashGreen;